import { render, staticRenderFns } from "./save-doi-paper-popup.html?vue&type=template&id=763f6144&scoped=true&external"
import script from "./save-doi-paper-popup.js?vue&type=script&lang=js&external"
export * from "./save-doi-paper-popup.js?vue&type=script&lang=js&external"
import style0 from "./save-doi-paper-popup.scss?vue&type=style&index=0&id=763f6144&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f6144",
  null
  
)

export default component.exports